// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class ExerciseAPI extends MainAPI {
	/**
	* @param {*} exerciseDetails
	*/
	async postExercise(exerciseDetails) {
		return API.post(ENDPOINTS.POST_EXERCISE, exerciseDetails);
	}

	/**
	* @param {*} exerciseDetails
	* @return {*} exercise list
	*/
	async getExercise(exerciseDetails) {
		return API.get(`${ENDPOINTS.GET_EXERCISE}?${queryString.stringify(exerciseDetails)}`);
	}

	/**
	 * @param {*} exerciseId
	 */
	async deleteExerciseById(exerciseId) {
		return API.delete(`${ENDPOINTS.DELETE_EXERCISE}/${exerciseId}`);
	}

	/**
	* @return NO CONTENT
	*/
	async putExercise(exerciseDetails, exerciseId) {
		return API.put(`${ENDPOINTS.PUT_EXERCISE}/${exerciseId}`, exerciseDetails);
	}
}

export default new ExerciseAPI();
